<template>
  <div>
    <!--**********************************
  Main wrapper start
***********************************-->
    <div id="main-wrapper">
      <!--**********************************
      Content body start
  ***********************************-->
      <div class="content-body pt-0 mb-5">
        <div class="container-fluid">
          <div
            class="form-head mb-sm-5 mb-3 d-flex flex-wrap align-items-center pt-3"
          >
            <h2 class="font-w600 title mb-2 mr-auto">
              {{ lan.admin[6].Quotes[0].Quotes }}
            </h2>
          </div>

          <div class="row">
            <div class="col-xl-12">
              <div class="card">
                <div class="card-header border-0 pb-0">
                  <h4 class="mb-0 fs-20 text-black">
                    {{ lan.admin[6].Quotes[0].Quotes_to_respond_to }}
                  </h4>
                  <span>Total: <strong>( {{ quotesNew.length }} )</strong></span>
                </div>
                <div class="card-body tab-content p-3">
                  <div class="tab-pane active show fade" id="monthly">
                    <div class="table-responsive">
                      <table
                        class="text-center bg-info-hover tr-rounded order-tbl"
                      >
                        <thead>
                          <tr>
                            <th>{{ lan.admin[6].Quotes[0].Quote}}</th>
                            <th>{{ lan.admin[6].Quotes[0].Customer }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Date }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Account }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Status }}</th>
                          </tr>
                        </thead>
                        <tbody
                          v-for="(data, index) in displayed_quotesNew"
                          :key="index"
                          @click="edit(data.quote_id)"
                          class="pointer"
                        >
                          <tr
                            v-if="
                              data.status == 'New' || data.status == 'Saved'
                            "
                          >
                          <td>{{ data.quote_id }}</td>
                            <td
                              v-if="
                                data.customer_account_detail &&
                                data.customer_account_detail.length
                              "
                            >
                              {{ data.customer_account_detail[0].name }}
                            </td>
                            <td v-else></td>
                            <!-- <td>{{ data.customer_account_detail[0].name }}</td> -->
                            <td>{{ data.date }}</td>
                            <td
                              :style="
                                data.account_detail.is_outside_partner == 1 || data.account_detail.is_outside_partner == '1'
                                  ? `background-color: #e4ecff`
                                  : ''
                              "
                            >
                              {{ data.account_detail.venue_name ? data.account_detail.venue_name : data.account_detail.name }}
                            </td>
                            <td>
                              <span
                                class="badge light"
                                :class="
                                  data.status == 'New'
                                    ? 'badge-success'
                                    : 'badge-warning'
                                "
                                >{{ data.status == 'New' ? lan.Status.New : lan.Status.Saved }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                        <div class="lds-ellipsis" v-show="value">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </table>
                      <div v-if="quotesNew.length > 5" class="text-right">
                        <button @click="toggleViewAll_quotesNew" class="view-all-less-btn">{{ showAll_quotesNew ? lan.Status.Show_less : lan.Status.Show_more }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12">
              <div class="card">
                <div class="card-header border-0 pb-0">
                  <h4 class="mb-0 fs-20 text-black">
                    {{ lan.admin[6].Quotes[0].Waiting_for_acceptance }}
                  </h4>
                  <span>Total: <strong>( {{ quotesSubmitted.length }} )</strong></span>
                </div>
                <div class="card-body tab-content p-3">
                  <div class="tab-pane active show fade" id="monthly">
                    <div class="table-responsive">
                      <table
                        class="text-center bg-info-hover tr-rounded order-tbl"
                      >
                        <thead>
                          <tr>
                            <th>{{ lan.admin[6].Quotes[0].Quote}}</th>
                            <th>{{ lan.admin[6].Quotes[0].Customer }}</th>
                            <th>
                              {{ lan.partners[1].quote[0].Preliminary_booked }}
                            </th>
                            <th>{{ lan.admin[6].Quotes[0].Date }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Account }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Status }}</th>
                          </tr>
                        </thead>
                        <tbody
                          v-for="(data, index) in displayed_quotesSubmitted"
                          :key="index"
                        >
                          <tr
                            v-if="
                              data.status == 'Submitted' ||
                              data.status == 'Preliminary Booked' ||
                              data.status == 'Preliminary Booking' ||
                              data.status == 'Preliminary Cancelled'
                            "
                          >
                          <td class="pointer">{{ data.quote_id }}</td>
                            <td
                              v-if="
                                data.customer_account_detail &&
                                data.customer_account_detail.length
                              "
                              class="pointer" @click="edit(data.quote_id)"
                            >
                              {{ data.customer_account_detail[0].name }}
                            </td>
                            <td v-else></td>
                            <!-- <td>{{ data.customer_account_detail[0].name }}</td> -->
                            <td class="pointer" @click="edit(data.quote_id)">
                              {{
                                data.status == "Preliminary Booked"
                                  ? "Yes"
                                  : "No"
                              }}
                            </td>
                            <td class="pointer" @click="edit(data.quote_id)">{{ data.date }}</td>
                            <td class="pointer" @click="edit(data.quote_id)" :style="
                                data.account_detail.is_outside_partner == 1 || data.account_detail.is_outside_partner == '1'
                                  ? `background-color: #e4ecff`
                                  : ''
                              ">{{ data.account_detail.venue_name ? data.account_detail.venue_name : data.account_detail.name}}</td>
                            <td class="pointer" @click="(data.status == 'Preliminary Booking' || data.status == 'Preliminary Booked') ? openPreliminaryBooking(data) : edit(data.quote_id)">
                              <span
                                class="badge light"
                                :class="
                                  data.status == 'Submitted'
                                    ? 'badge-info'
                                    : data.status == 'Preliminary Booked'
                                    ? 'badge-success'
                                    : data.status == 'Preliminary Booking'
                                    ? 'badge-warning'
                                    : 'badge-danger'
                                "
                                >{{ data.status == 'Submitted'
                                    ? lan.Status.Submitted
                                    : data.status == 'Preliminary Booked'
                                    ? lan.Status.Preliminary_Booked
                                    : data.status == 'Preliminary Booking'
                                    ? lan.Status.Preliminary_Booking
                                    : lan.Status.Preliminary_Cancelled }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                        <div class="lds-ellipsis" v-show="value">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </table>.
                      <div v-if="quotesSubmitted.length > 5" class="text-right">
                        <button @click="toggleViewAll_quotesSubmitted" class="view-all-less-btn">{{ showAll_quotesSubmitted ? lan.Status.Show_less : lan.Status.Show_more }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12">
              <div class="card">
                <div class="card-header border-0 pb-0">
                  <h4 class="mb-0 fs-20 text-black">
                    {{ lan.admin[6].Quotes[0].Accepted_quotes }}
                  </h4>
                  <span>Total: <strong>( {{ quotesAccepted.length }} )</strong></span>
                </div>
                <div class="card-body tab-content p-3">
                  <div class="tab-pane active show fade" id="monthly">
                    <div class="table-responsive">
                      <table
                        class="text-center bg-info-hover tr-rounded order-tbl"
                      >
                        <thead>
                          <tr>
                            <th>{{ lan.admin[6].Quotes[0].Quote }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Customer }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Date }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Account }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Status }}</th>
                          </tr>
                        </thead>
                        <tbody
                          v-for="(data, index) in displayed_quotesAccepted"
                          :key="index"
                          @click="edit(data.quote_id)"
                          class="pointer"
                        >
                          <tr v-if="data.status == 'Accepted'">
                            <td>{{ data.quote_id }}</td>
                            <td
                              v-if="
                                data.customer_account_detail &&
                                data.customer_account_detail.length
                              "
                            >
                              {{ data.customer_account_detail[0].name }}
                            </td>
                            <td v-else></td>
                            <!-- <td>{{ data.customer_account_detail[0].name }}</td> -->
                            <td>{{ data.date }}</td>
                            <td :style="
                                data.account_detail.is_outside_partner == 1 || data.account_detail.is_outside_partner == '1'
                                  ? `background-color: #e4ecff`
                                  : ''
                              ">{{ data.account_detail.venue_name ? data.account_detail.venue_name : data.account_detail.name}}</td>
                            <td>
                              <span
                                class="badge light"
                                :class="
                                  data.status == 'Accepted'
                                    ? 'badge-success'
                                    : 'badge-warning'
                                "
                                >{{ data.status == 'Accepted' ? lan.Status.Accepted : data.status }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                        <div class="lds-ellipsis" v-show="value">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </table>
                      <div v-if="quotesAccepted.length > 5" class="text-right">
                        <button @click="toggleViewAll_quotesAccepted" class="view-all-less-btn">{{ showAll_quotesAccepted ? lan.Status.Show_less : lan.Status.Show_more }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12">
              <div class="card">
                <div class="card-header border-0 pb-0">
                  <h4 class="mb-0 fs-20 text-black">
                    {{ lan.admin[6].Quotes[0].Accepted_Denied }}
                  </h4>
                  <span>Total: <strong>( {{ quotesDenied.length }} )</strong></span>
                </div>
                <div class="card-body tab-content p-3">
                  <div class="tab-pane active show fade" id="monthly">
                    <div class="table-responsive">
                      <table
                        class="text-center bg-info-hover tr-rounded order-tbl"
                      >
                        <thead>
                          <tr>
                            <th>{{ lan.admin[6].Quotes[0].Quote }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Customer }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Date }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Account }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Status }}</th>
                          </tr>
                        </thead>
                        <tbody
                          v-for="(data, index) in displayed_quotesDenied"
                          :key="index"
                          @click="edit(data.quote_id)"
                          class="pointer"
                        >
                          <tr v-if="data.status == 'Denied'">
                            <td>{{ data.quote_id }}</td>
                            <td
                              v-if="
                                data.customer_account_detail &&
                                data.customer_account_detail.length
                              "
                            >
                              {{ data.customer_account_detail[0].name }}
                            </td>
                            <td v-else></td>
                            <!-- <td>{{ data.customer_account_detail[0].name }}</td> -->
                            <td>{{ data.date }}</td>
                            <td>{{ data.account_detail.venue_name ? data.account_detail.venue_name : data.account_detail.name}}</td>
                            <td>
                              <span
                                class="badge light"
                                :class="
                                  data.status == 'Denied'
                                    ? 'badge-danger'
                                    : 'badge-success'
                                "
                                >{{ data.status == 'Denied' ? lan.Status.Denied : data.status }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                        <div class="lds-ellipsis" v-show="value">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </table>
                      <div v-if="quotesDenied.length > 5" class="text-right">
                        <button @click="toggleViewAll_quotesDenied" class="view-all-less-btn">{{ showAll_quotesDenied ? lan.Status.Show_less : lan.Status.Show_more }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12">
              <div class="card">
                <div class="card-header border-0 pb-0">
                  <h4 class="mb-0 fs-20 text-black">
                    {{ lan.admin[6].Quotes[0].Quote_lost }}
                  </h4>
                  <span>Total: <strong>( {{ quotesLost.length }} )</strong></span>
                </div>
                <div class="card-body tab-content p-3">
                  <div class="tab-pane active show fade" id="monthly">
                    <div class="table-responsive">
                      <table
                        class="text-center bg-info-hover tr-rounded order-tbl"
                      >
                        <thead>
                          <tr>
                            <th>{{ lan.admin[6].Quotes[0].Quote }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Customer }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Date }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Account }}</th>
                            <th>{{ lan.admin[6].Quotes[0].Status }}</th>
                          </tr>
                        </thead>
                        <tbody
                          v-for="(data, index) in displayed_quotesLost"
                          :key="index"
                          @click="edit(data.quote_id)"
                          class="pointer"
                        >
                          <tr v-if="data.status == 'Lost'">
                            <td>{{ data.quote_id }}</td>
                            <td
                              v-if="
                                data.customer_account_detail &&
                                data.customer_account_detail.length
                              "
                            >
                              {{ data.customer_account_detail[0].name }}
                            </td>
                            <td v-else></td>
                            <!-- <td>{{ data.customer_account_detail[0].name }}</td> -->
                            <td>{{ data.date }}</td>
                            <td>{{ data.account_detail.venue_name ? data.account_detail.venue_name : data.account_detail.name}}</td>
                            <td>
                              <span
                                class="badge light"
                                :class="
                                  data.status == 'Lost'
                                    ? 'badge-danger'
                                    : 'badge-success'
                                "
                                >{{ data.status == 'Lost' ? lan.Status.Lost : data.status }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                        <div class="lds-ellipsis" v-show="value">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </table>
                      <div v-if="quotesLost.length > 5" class="text-right">
                        <button @click="toggleViewAll_quotesDenied" class="view-all-less-btn">{{ showAll_quotesLost ? lan.Status.Show_less : lan.Status.Show_more }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <pagination
                  :current_page="current_page"
                  :total="total"
                  :per_page="per_page"
                  :totalPages="totalPages"
                  :loadingPageButton="loadingPageButton"
                  @page-change="getAllQuotes"
                /> -->
          </div>
        </div>
      </div>
      <!--**********************************
      Content body end
  ***********************************-->
    </div>
    <!--**********************************
  Main wrapper end
***********************************-->
  </div>
</template>

<script>
import axios from "axios";
import pagination from "../../../components/partials/pagination.vue";
// @ is an alias to /src

export default {
  name: "Quotes",
  components: {
    pagination
  },
  data() {
    return {
      quotesDetails: "",
      quotesNew: [],
      quotesSubmitted: [],
      quotesAccepted: [],
      quotesDenied: [],
      quotesLost: [],
      showAll_quotesNew: false,
      showAll_quotesSubmitted: false,
      showAll_quotesAccepted: false,
      showAll_quotesDenied: false,
      showAll_quotesLost: false,
      value: true,
      loadingPageButton: 0,

      current_page:0,
      per_page:0,
      total:0,
      totalPages:0,
    };
  },

  computed: {
    lan() {
      return this.$store.getters.whichLanguage;
    },
    displayed_quotesNew() {
      return this.showAll_quotesNew ? this.quotesNew : this.quotesNew.slice(0, 5);
    },
    displayed_quotesSubmitted() {
      return this.showAll_quotesSubmitted ? this.quotesSubmitted : this.quotesSubmitted.slice(0, 5);
    },
    displayed_quotesAccepted() {
      return this.showAll_quotesAccepted ? this.quotesAccepted : this.quotesAccepted.slice(0, 5);
    },
    displayed_quotesDenied() {
      return this.showAll_quotesDenied ? this.quotesDenied : this.quotesDenied.slice(0, 5);
    },
    displayed_quotesLost() {
      return this.showAll_quotesLost ? this.quotesLost : this.quotesLost.slice(0, 5);
    },
  },
  methods: {
    getAllQuotes(page){
      this.loadingPageButton = page
      axios
      .get(axios.defaults.baseURL + "quotes" + (typeof page === "number" && page > 0 ? `?page=${page}` : ""), {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        console.log('res----/--', res);
        
        this.value = false;
        this.quotesDetails = res.data.data.data;
        this.current_page = res.data.data.current_page,
        this.per_page = res.data.data.per_page,
        this.total = res.data.data.total,
        this.totalPages = res.data.data.last_page,
        // this.quotesNew = res.data.data.filter((item) => item.status == "New");
        this.quotesSubmitted = [],
        this.quotesAccepted = [],
        this.quotesDenied = [],
        this.quotesLost = [],
        res.data.data.data.forEach(element => {
          if(element.status == "New" || element.status == "Saved")this.quotesNew.push(element)
          else if(element.status == "Submitted" || element.status == "Preliminary Booked" || element.status == "Preliminary Booking" || element.status == "Preliminary Cancelled")this.quotesSubmitted.push(element)
          else if(element.status == "Accepted") this.quotesAccepted.push(element)
          else if(element.status == "Denied") this.quotesDenied.push(element)
          else if(element.status == "Lost") this.quotesLost.push(element)
        });
        this.loadingPageButton = 0
      })
      .catch((err) => {
        this.value = false;
        this.loadingPageButton = 0
        this.$store.dispatch("checkErrorAndSendToast", [
          err.response,
          "error",
        ]);
      });
    },
    toggleViewAll_quotesNew() {
      this.showAll_quotesNew = !this.showAll_quotesNew;
    },
    toggleViewAll_quotesSubmitted() {
      this.showAll_quotesSubmitted = !this.showAll_quotesSubmitted;
    },
    toggleViewAll_quotesAccepted() {
      this.showAll_quotesAccepted = !this.showAll_quotesAccepted;
    },
    toggleViewAll_quotesDenied() {
      this.showAll_quotesDenied = !this.showAll_quotesDenied;
    },
    toggleViewAll_quotesDenied() {
      this.showAll_quotesLost = !this.showAll_quotesLost;
    },
    openPreliminaryBooking(data){
      console.log('data', data);
      console.log('bidderID', data._id);
      this.$router.push({
        name: "Preliminary Booking",
        params: { 
          id: data.opportunity_id, 
          qID: data.quote_id,
          cutomerID: data.customer_account_id,
          bidderID: data.bidder_id,
          bookingID: data.preliminary_booking_id,
        },
      });
    },
    edit(id) {
      localStorage.setItem("editID", id);
      this.$router.push({
        name: "Edit Quote",
        params: { id: id },
      });
    },
  },
  mounted() {
    // for top load page
    window.scrollTo(0, 0);

    // // *********GET quotes***********
    this.getAllQuotes()

  },
 
};
</script>
